function contactsHost() {
    const raw = import.meta.env.VITE_APP_CONTACTS_API_URL || "https://control.x-cube.nl";
    return String(raw).replace(/\/$/, "");
}

function getToken() {
    return localStorage.getItem("xcube-session-key");
}

/** Default form shape for the locationsupport BFF / Airtable LocationEmails table. */
export function emptyContactForm() {
    return {
        /** Hub/BFF id for the Airtable record; not an Airtable column name. */
        recordId: null,
        first_name: "",
        last_name: "",
        function: "",
        /** Airtable column name (Dutch label in the base schema). */
        emailadres: "",
        /** Airtable column name. */
        actief: true,
        receive_monitoring: false,
        telephone_mobile: "",
        telephone_location: "",
        locationIds: [],
        /** Airtable single-select values (Nederlands, Engels, …), not ISO codes. */
        Language: "",
    };
}

export class ContactsApiError extends Error {
    constructor(message, status, body) {
        super(message);
        this.name = "ContactsApiError";
        this.status = status;
        this.body = body;
    }
}

async function contactsRequest(path, { method = "GET", body } = {}) {
    const token = getToken();
    const res = await fetch(`${contactsHost()}${path}`, {
        method,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body === undefined ? undefined : JSON.stringify(body),
    });

    let json = {};
    try {
        json = await res.json();
    } catch {
        // Empty or non-JSON bodies still have a usable HTTP status.
        json = {};
    }

    if (res.status === 401) {
        // Hub login JWT can be valid while the Contacts BFF rejects it (e.g. testhub →
        // api.test JWT against a prod-Strapi BFF). Do not wipe the Hub session.
        throw new ContactsApiError(
            json.error || "Contacts session rejected by the API",
            401,
            json,
        );
    }

    if (!res.ok || json.ok === false) {
        throw new ContactsApiError(
            json.error || "Request failed",
            res.status,
            json,
        );
    }

    return json;
}

export async function listContacts({ locationId } = {}) {
    const params = new URLSearchParams();
    if (locationId && locationId !== "all") {
        params.set("location_id", String(locationId));
    }
    const query = params.toString();
    return contactsRequest(
        `/api/hub/location-emails${query ? `?${query}` : ""}`,
    );
}

export async function getContact(recordId) {
    return contactsRequest(
        `/api/hub/location-emails/${encodeURIComponent(recordId)}`,
    );
}

export async function createContact(form) {
    return contactsRequest("/api/hub/location-emails", {
        method: "POST",
        body: { form: { ...form, recordId: null } },
    });
}

export async function updateContact(recordId, form) {
    return contactsRequest(
        `/api/hub/location-emails/${encodeURIComponent(recordId)}`,
        {
            method: "PUT",
            body: { form: { ...form, recordId } },
        },
    );
}

export async function deactivateContact(recordId) {
    return contactsRequest(
        `/api/hub/location-emails/${encodeURIComponent(recordId)}`,
        { method: "DELETE" },
    );
}
